import type { AllRouteEndpoints } from "../routeTypes";

export const postAppGroupIdBrazeMcpCallToolCacheKeys: AllRouteEndpoints[] = [];
